/*
 * Vue实例创建
 * 要求在创建前，环境中必须加载Vue.js
 * 在创建实例时，将options中SWF的配置项和Vue上传组件做一个适配
 * @author sy
 * @date 2018-3-23
 */

import MIME from './upload-mime.json'
import UploadList from '../upload_list/upload-list'

/**
 * MINETYPE 类型转换
 * @param file_types
 */

function mineType (fileTypes) {
  if (!fileTypes || fileTypes === '*') {
    return '*'
  }
  let fts = fileTypes.split(';')
  let res = []
  for (let i of fts) {
    if (MIME[i]) {
      res.push(MIME[i])
    } else {
      res.push(i)
    }
  }
  return res.join(',')
}

/**
 * 实例Vue对象
 * @description 创建Vue对象前必须在环境中加载Vue
 * @param options
 * @returns {CombinedVueInstance<V extends Vue, Object, Object, Object, Record<never, any>> | Vue | *}
 */

export default function initVue (options) {
  if (window.Vue) {
    try {
      return new window.Vue({
        el: '#app',
        data: {
          text: options.text,
          isApprove: options.isApprove,
          btnStyle: options.btnStyle,
          upload_url: options.upload_url,
          headers: options.headers,
          file_post_name: options.file_post_name,
          post_params: options.post_params,
          file_types: mineType(options.file_types),
          file_size_limit: options.file_size_limit,
          file_queue_limit: options.file_queue_limit,
          file_upload_limit: options.file_upload_limit,
          multiple: options.multiple
        },
        methods: {
          handleUploadClick () {
            if (options.isApprove === true) {
              console.log(1)
            } else {
              options.file_dialog_start_handler()
            }
          },
          handleUploadChange (file, fileList) {
            options.file_queued_handler.call(this, file)
          },
          handleDialogComplete (filesSelected, filesQueued) {
            // 使用call是希望调用者可以使用this.startUpload()手动上传
            options.file_dialog_complete_handler.call(this, filesSelected, filesQueued)
          },
          handleQueueError (err, file) {
            return options.file_queue_error_handler(file, err.code, err.message)
          },
          handleUploadBefore (file) {
            return new Promise((resolve, reject) => {
              this.$nextTick(() => {
                let res = options.upload_start_handler.call(this, file)
                if (res.result) {
                  resolve(this.upload_url)
                } else {
                  /* eslint-disable */
                  reject(res.message)
                }
              })
            })
          },
          handleUploadProgress (e, file, fileList) {
            options.upload_progress_handler(file, e.loaded, e.total)
          },
          handleUploadSuccess (res, file) {
            options.upload_success_handler(file, res, '')
          },
          handleUploadError (err, file) {
            return options.upload_error_handler(file, err.code, err.message)
          },
          handleUploadPreview (file) {

          },
          handleUploadRemove(file){

          },
          handleUploadCancel (file) {

          },
          handleUploadCancelAll (fileList) {

          },
          startUpload () {
            this.$children[0].startUpload()
          },
          cancelUpload (fid) {
            this.$children[0].cancelUpload(fid)
          },
          /**
           * 设置上传URL
           * @param url
           * @description 在upload_start_handler中可以调用this.setUploadURL在上传前最后一步改变URL
           */
          setUploadURL (url) {
            if (url && url !== '') {
              this.upload_url = url
            } else {
              throw new Error('URL undefined!')
            }
          },
          listError (message, file) {
            UploadList.prototype.error(message, file)
          },
          listShow(){
            UploadList.prototype.show()
            if (location.href.indexOf('/link/view') <= -1 && localStorage.approveExist === 'true') {
              UploadList.prototype.listMaskShow() // 审批遮罩层
            } else {
              UploadList.prototype.listMaskHide() // 审批遮罩层隐藏
            }
          },
          listAdd(file){
            UploadList.prototype.add(file)
          },
          listClose(){
            UploadList.prototype.closed()
          }
        }
      })
    }
    catch (e){
      console.log("初始化业务失败!")
      window.location.reload()
      return false
    }
  } else {
    throw new Error('Vue not found in window!')
  }
}



// WEBPACK FOOTER //
// ./src/components/upload/upload_vue/index.js